import React, { useState, useEffect } from "react";
import Breadcrumb from "../../../../../../components/Breadcrum";
import { ArrowRight } from "lucide-react";
import "./Figs.css";

export default function Figs() {
    const figProducts = [
        {
            id: 1,
            name: "TURKISH FIGS",
            image: "/assets/img/Figs/Turkish-Figs.jpg",
            usage: [
                {
                    title: "Where It's Used",
                    points: [
                        "Premium dry fruit packs",
                        "Bakery products",
                        "Healthy snack foods",
                        "Gift packaging",
                    ],
                },
                {
                    title: "Why It's Used",
                    points: [
                        "Naturally sweet flavor",
                        "Soft chewy texture",
                        "High fiber content",
                        "Globally preferred variety",
                    ],
                },
            ],
        },

        {
            id: 2,
            name: "IRANIAN FIGS",
            image: "/assets/img/Figs/Iranian-Figs.jpg",
            usage: [
                {
                    title: "Where It's Used",
                    points: [
                        "Dry fruit mixes",
                        "Retail packaging",
                        "Traditional food products",
                        "Healthy snack packs",
                    ],
                },
                {
                    title: "Why It's Used",
                    points: [
                        "Rich nutritional value",
                        "Distinct natural taste",
                        "Long shelf life",
                        "Cost-effective premium quality",
                    ],
                },
            ],
        },

        {
            id: 3,
            name: "PREMIUM DRIED FIGS",
            image: "/assets/img/Figs/Premium-Dried-Figs.jpg",
            usage: [
                {
                    title: "Where It's Used",
                    points: [
                        "Luxury dry fruit boxes",
                        "Confectionery industry",
                        "Bakery applications",
                        "Health food products",
                    ],
                },
                {
                    title: "Why It's Used",
                    points: [
                        "Premium appearance",
                        "Excellent sweetness",
                        "Rich in dietary fiber",
                        "High market demand",
                    ],
                },
            ],
        },
    ];
    const defaultImage =
        "https://upload.wikimedia.org/wikipedia/commons/7/79/Polypropylene_%28PP%29_Granules.jpg";

    const [selectedProduct, setSelectedProduct] = useState(null);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <>
            <Breadcrumb
                title="Figs (Anjeer)"
                backgroundImage="./assets/img/contact-banner.png"
                height="40vh"
            />

            <section className="pp-section">
                <div className="container">
                    <h1 className="pp-title">Figs Product Range</h1>

                    <p className="pp-subtitle">
                        Explore our premium quality Figs (Anjeer) products sourced from
                        trusted suppliers worldwide.
                    </p>

                    <div className="pp-grid">
                        {figProducts.map((product) => (
                            <div className="pp-card" key={product.id}>
                                <div className="pp-img-box">
                                    <img
                                        src={product.image || defaultImage}
                                        alt={product.name}
                                        onError={(e) => (e.target.src = defaultImage)}
                                    />
                                </div>

                                <div className="pp-info">
                                    <h2 className="pp-name">{product.name}</h2>

                                    <button
                                        className="view-btn"
                                        onClick={() => setSelectedProduct(product)}
                                    >
                                        View Details <ArrowRight size={16} />
                                    </button>
                                </div>
                            </div>
                        ))}
                    </div>

                    {selectedProduct && (
                        <div
                            className="modal-overlay"
                            onClick={() => setSelectedProduct(null)}
                        >
                            <div
                                className="modal-content"
                                onClick={(e) => e.stopPropagation()}
                            >
                                <img
                                    src={selectedProduct.image || defaultImage}
                                    alt={selectedProduct.name}
                                    className="modal-image"
                                />

                                <h2 className="modal-title">{selectedProduct.name}</h2>

                                <div className="usage-section">
                                    {selectedProduct.usage.map((section, index) => (
                                        <div key={index} className="usage-block">
                                            <h3>{section.title}</h3>

                                            <ul>
                                                {section.points.map((point, i) => (
                                                    <li key={i}>{point}</li>
                                                ))}
                                            </ul>
                                        </div>
                                    ))}
                                </div>

                                <button
                                    className="close-btn"
                                    onClick={() => setSelectedProduct(null)}
                                >
                                    Close
                                </button>
                            </div>
                        </div>
                    )}
                </div>
            </section>
        </>
    );
}